import { render } from "./LegacyLoops.vue?vue&type=template&id=23e3065a"
import script from "./LegacyLoops.vue?vue&type=script&lang=js"
export * from "./LegacyLoops.vue?vue&type=script&lang=js"

import "./LegacyLoops.vue?vue&type=style&index=0&id=23e3065a&lang=scss"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__